import { render } from "./TablaEstadoEquipos.vue?vue&type=template&id=53c8c2f7"
import script from "./TablaEstadoEquipos.vue?vue&type=script&lang=js"
export * from "./TablaEstadoEquipos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maguilar/Dev/repos/garantias-transelec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__